import { render, staticRenderFns } from "./SiteStatsTableV2.vue?vue&type=template&id=fa94246a&scoped=true&"
import script from "./SiteStatsTableV2.vue?vue&type=script&lang=js&"
export * from "./SiteStatsTableV2.vue?vue&type=script&lang=js&"
import style0 from "./SiteStatsTableV2.vue?vue&type=style&index=0&id=fa94246a&prod&lang=css&"
import style1 from "./SiteStatsTableV2.vue?vue&type=style&index=1&id=fa94246a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa94246a",
  null
  
)

export default component.exports